"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function promisifySynchronousMethod(methodToPromisify) {
    try {
        var result = methodToPromisify();
        return Promise.resolve(result);
    }
    catch (e) {
        return Promise.reject(e);
    }
}
exports.promisifySynchronousMethod = promisifySynchronousMethod;
